import axios from "axios";

let envPath = process.env.API_URL;

const session = axios.create({
  baseURL: envPath,
  headers: {
    Accept: "application/json",
    "content-type": "application/json",
  },
  withCredentials: true,
});

export default session;
